"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImage = exports.imageSchema = void 0;
var yup = require("yup");
exports.imageSchema = yup.object().shape({
    width: yup.number().required(),
    height: yup.number().required(),
    url: yup.string().required(),
});
function isImage(obj) {
    return exports.imageSchema.isValidSync(obj);
}
exports.isImage = isImage;
